import HomeView from '@view/HomeView.vue'
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: "/factureren-glasbewassing-csu",
    name: "Forms.Glasbewassing",
    component: () => import("@view/forms/GlasbewassingCsuView.vue")
  },
  {
    path: "/referentie-code",
    name: "Forms.ReferenceCode",
    component: () => import("@view/forms/ReferenceGeneratorView.vue")
  },
  {
    path: "/calamiteiten-reiniging",
    name: "Forms.CalamiteitenReiniging",
    component: () => import("@view/forms/CalamiteitenReinigingView.vue")
  },
  {
    path: "/project-prijs",
    name: "Forms.ProjectPrice",
    component: () => import("@view/forms/ProjectPriceView.vue")
  },
  {
    path: "/regie-prijs",
    name: "Forms.HourlyPrice",
    component: () => import("@view/forms/HourlyPriceView.vue")
  },
  {
    path: "/taken-registratie",
    name: "Forms.TaskRegister",
    component: () => import("@view/forms/TaskRegisterView.vue")
  },
  {
    path: "/admin",
    children: [
      {
        path: "",
        name: "Admin.Dashboard",
        component: () => import("@view/admin/DashboardView.vue")
      },
      {
        path: "information",
        name: "Admin.Information",
        component: () => import("@view/admin/InformationView.vue")
      },
      {
        path: "data-management",
        children: [
          {
            path: "employees",
            component: () => import("@view/admin/data-management/employees/Index.vue"),
            children: [
              {
                path: "dashboard",
                name: "Admin.Data.Employees.Dashboard",
                component: () => import("@view/admin/data-management/employees/DashboardView.vue")
              },
              {
                path: "add",
                name: "Admin.Data.Employees.Add",
                component: () => import("@view/admin/data-management/employees/AddView.vue")
              }
            ]
          },
          {
            path: "company",
            component: () => import("@view/admin/data-management/companies/Index.vue"),
            children: [
              {
                path: "dashboard",
                name: "Admin.Data.Companies.Dashboard",
                component: () => import("@view/admin/data-management/companies/DashboardView.vue")
              },
              {
                path: "add",
                name: "Admin.Data.Companies.Add",
                component: () => import("@view/admin/data-management/companies/AddView.vue")
              }
            ]
          },
          {
            path: "objects",
            component: () => import("@view/admin/data-management/objects/Index.vue"),
            children: [
              {
                path: "dashboard",
                name: "Admin.Data.Objects.Dashboard",
                component: () => import("@view/admin/data-management/objects/DashboardView.vue")
              },
              {
                path: "add",
                name: "Admin.Data.Objects.Add",
                component: () => import("@view/admin/data-management/objects/AddView.vue")
              }
            ]
          },
          {
            path: "contact-persons",
            component: () => import("@view/admin/data-management/contact-persons/Index.vue"),
            children: [
              {
                path: "dashboard",
                name: "Admin.Data.ContactPersons.Dashboard",
                component: () => import("@view/admin/data-management/contact-persons/DashboardView.vue")
              },
              {
                path: "add",
                name: "Admin.Data.ContactPersons.Add",
                component: () => import("@view/admin/data-management/contact-persons/AddView.vue")
              }
            ]
          },
          {
            path: "services",
            component: () => import("@view/admin/data-management/services/Index.vue"),
            children: [
              {
                path: "dashboard",
                name: "Admin.Data.Services.Dashboard",
                component: () => import("@view/admin/data-management/services/DashboardView.vue")
              },
              {
                path: "add",
                name: "Admin.Data.Services.Add",
                component: () => import("@view/admin/data-management/services/AddView.vue")
              }
            ]
          },
          {
            path: "disasters",
            component: () => import("@view/admin/data-management/disasters/Index.vue"),
            children: [
              {
                path: "dashboard",
                name: "Admin.Data.Disasters.Dashboard",
                component: () => import("@view/admin/data-management/disasters/DashboardView.vue")
              },
              {
                path: "add",
                name: "Admin.Data.Disasters.Add",
                component: () => import("@view/admin/data-management/disasters/AddView.vue")
              }
            ]
          },
          {
            path: "materials",
            component: () => import("@view/admin/data-management/materials/Index.vue"),
            children: [
              {
                path: "dashboard",
                name: "Admin.Data.Materials.Dashboard",
                component: () => import("@view/admin/data-management/materials/DashboardView.vue")
              },
              {
                path: "add",
                name: "Admin.Data.Materials.Add",
                component: () => import("@view/admin/data-management/materials/AddView.vue")
              }
            ]
          },
          {
            path: "resources",
            component: () => import("@view/admin/data-management/resources/Index.vue"),
            children: [
              {
                path: "dashboard",
                name: "Admin.Data.Resources.Dashboard",
                component: () => import("@view/admin/data-management/resources/DashboardView.vue")
              },
              {
                path: "add",
                name: "Admin.Data.Resources.Add",
                component: () => import("@view/admin/data-management/resources/AddView.vue")
              }
            ]
          }
        ]
      },
      {
        path: "glasbewassing-csu",
        children: [
          {
            path: "dashboard",
            name: "Admin.Forms.Glasbewassing.Dashboard",
            component: () => import("@view/admin/glasbewassing-csu/DashboardView.vue")
          },
          {
            path: "manage/:id",
            name: "Admin.Forms.Glasbewassing.Manage",
            component: () => import("@view/admin/glasbewassing-csu/ManageView.vue")
          }
        ]
      },
      {
        path: "referentie-codes",
        children: [
          {
            path: "dashboard",
            name: "Admin.Forms.Reference.Dashboard",
            component: () => import("@view/admin/reference-code/DashboardView.vue")
          },
          {
            path: "manage/:code",
            name: "Admin.Forms.Reference.Manage",
            component: () => import("@view/admin/reference-code/ManageView.vue")
          }
        ]
      },
      {
        path: "calamiteiten-reiniging",
        children: [
          {
            path: "dashboard",
            name: "Admin.Forms.Calamiteiten.Dashboard",
            component: () => import("@view/admin/calamiteiten-reiniging/DashboardView.vue")
          },
          {
            path: "manage/:id",
            name: "Admin.Forms.Calamiteiten.Manage",
            component: () => import("@view/admin/calamiteiten-reiniging/ManageView.vue")
          }
        ]
      },
      {
        path: "project-prijs",
        children: [
          {
            path: "dashboard",
            name: "Admin.Forms.ProjectPrice.Dashboard",
            component: () => import("@view/admin/project-prijs/DashboardView.vue")
          },
          {
            path: "manage/:id",
            name: "Admin.Forms.ProjectPrice.Manage",
            component: () => import("@view/admin/project-prijs/ManageView.vue")
          }
        ]
      },
      {
        path: "regie-prijs",
        children: [
          {
            path: "dashboard",
            name: "Admin.Forms.HourlyPrice.Dashboard",
            component: () => import("@view/admin/regie-prijs/DashboardView.vue")
          },
          {
            path: "manage/:id",
            name: "Admin.Forms.HourlyPrice.Manage",
            component: () => import("@view/admin/regie-prijs/ManageView.vue")
          }
        ]
      },
      {
        path: "secret",
        children: [
          {
            path: "task-register",
            children: [
              {
                path: "dashbhoard",
                name: "Admin.Secret.Forms.TaskRegister.Dashboard",
                component: () => import("@view/admin/secret/task-register/DashboardView.vue")
              },
              {
                path: "manage/:id",
                name: "Admin.Secret.Forms.TaskRegister.Manage",
                component: () => import("@view/admin/secret/task-register/ManageView.vue")
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/:catchAll(.*)*',
    component: HomeView
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;